//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: "ChangeDialog",
  props: {
    // 弹窗是否显示
    showDialog: {
      type: Boolean,
      default: false,
    },
    dataList: {
      type: Array,
      default: () => [],
    },
    type: {
      type: String,
      default: () => "coo",
    },
  },
  data() {
    return {
      currentForm: { businessZoneId: "", businessPersonId: "" }, // 当前表单提交参数
      currentRules: {}, // 当前表单验证
      node: {}, // 选中区域数据
      businessZoneList: [], // 区域数据
      optionPersonList: [], // 业务员列表
    };
  },
  computed: {},
  methods: {
    /**
     * @description: 关闭弹窗
     * @Author: yangsibo
     * @Date: 2022-05-13 14:19:50
     */
    close() {
      this.$emit("close");
    },
    /**
     * @description: 保存当前表单
     * @Author: yangsibo
     * @Date: 2022-05-13 08:50:05
     */
    confirmCurrent() {
      if (!this.currentForm.businessZoneId) {
        this.$message({
          type: "warning",
          message: "请选择业务区域",
          duration: 2000,
        });
        return false;
      }
      if (!this.currentForm.businessPersonId) {
        this.$message({
          type: "warning",
          message: "请选择业务员",
          duration: 2000,
        });
        return false;
      }
      this.currentForm.ids = this.dataList.map((val) => {
        return val.id;
      });
      this.updateCustomer(this.currentForm);
    },
    /**
     * @description: 更换区域和业务员
     * @Author: yangsibo
     * @Date: 2022-05-16 15:43:38
     * @param {*} params 参数
     * @return {*}
     */
    async updateCustomer(params) {
      try {
        let { status } = await this.$http.business.updateCustomer(
          params,
          this.type
        );
        if (status === "1") {
          this.$message({
            type: "success",
            message: "操作成功",
            duration: 2000,
          });
          this.$emit("close");
          this.$emit("refreshList");
        }
      } catch (error) {}
    },
    /**
     * @description: 获取业务区域树
     * @Author: yangsibo
     * @Date: 2022-05-12 10:20:36
     */
    async getBusinessZoneList(callback) {
      try {
        let { data } = await this.$http.common.getBusinessZoneList();
        this.businessZoneList = data;
        callback && callback();
      } catch (error) {}
    },
    /**
     * @description: 选中更改后区域
     * @Author: yangsibo
     * @Date: 2022-05-18 08:53:03
     * @param data
     * @param checked
     * @return {*}
     */
    handleOptionClick(data, checked) {
      if (checked) {
        this.node = data;
        this.currentForm.businessPersonId = "";
        this.currentForm.businessZoneId = data.id;
        this.$refs.selectTree.blur();
        this.$nextTick(() => {
          this.$refs.selectedTree.setCurrentKey(this.node.id);
          this.getPersonListbyZoneId(data.id);
        });
      }
    },
    /**
     * @description: 获取业务员列表
     * @Author: yangsibo
     * @Date: 2022-05-12 14:35:20
     * @param {*} id 区域id
     * @return {*}
     */
    async getPersonListbyZoneId(id) {
      try {
        let { data } = await this.$http.business.getPersonListbyZoneId({
          businessZoneId: id,
        });
        this.optionPersonList = data ? data : [];
      } catch (error) {}
    },
  },
  created() {},
  mounted() {
    this.getBusinessZoneList();
  },
  watch: {},
};
